import type React from 'react';

import { Button, Input } from '../../components';
import { ArrowBack } from '../../components/Icons/ArrowBack';

interface FormForgotProps {
	back: (view: string) => void;
}

export const FormForgot = ({ back }: FormForgotProps) => {
	const HandleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
	};
	return (
		<div className="login__form">
			<div className="login__title">
				Recuperar <span>contraseña</span>
			</div>

			<form onSubmit={HandleSubmit}>
				<div className="back" onClick={() => back('login')}>
					<ArrowBack className="back__arrow" />
					Volver
				</div>
				<div className="login__label">Para recuperar ingrese su correo</div>
				<Input
					name="email"
					//change={handleInputChange}
					//error={errors.email}
					placeholder="Correo"
					autoComplete="off"
				/>
				<div className="form__bottom">
					<Button type="submit" text="Recuperar" size="medium" />
				</div>
			</form>
		</div>
	);
};
